var _path, _path2, _path3, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4901_45311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 23,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 22.6923L9.47878 6.05888C9.41231 5.7981 9.29758 5.55363 9.14112 5.33944C8.98467 5.12524 8.78956 4.94552 8.56694 4.81053C8.34432 4.67554 8.09856 4.58794 7.8437 4.55272C7.58883 4.5175 7.32986 4.53536 7.08157 4.60528V4.60528C6.83336 4.67522 6.6007 4.79582 6.39688 4.96018C6.19306 5.12455 6.02206 5.32946 5.89364 5.56322C5.76523 5.79699 5.68192 6.05502 5.64847 6.3226C5.61502 6.59017 5.63208 6.86205 5.69868 7.1227L9.6712 22.6923",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0362 22.6934V26.8034H25.0392C25.5582 26.8034 26.0559 26.5869 26.4229 26.2015C26.7899 25.8161 26.9961 25.2934 26.9961 24.7484C26.9961 24.2034 26.7899 23.6807 26.4229 23.2953C26.0559 22.9099 25.5582 22.6934 25.0392 22.6934H10.0362Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 18.0684H13.1055",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4901_45311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.171 -3.33789H-2.92969V37.7628H38.171V-3.33789Z",
    fill: "#1B2646"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.89844,
    y: 5.31836,
    width: 4.53912,
    height: 20.2359,
    rx: 2.26956,
    transform: "rotate(-14.0456 4.89844 5.31836)",
    fill: "#1B2646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeats);
export default __webpack_public_path__ + "static/media/seats.5c70fa184267e22180383f5c80159729.svg";
export { ForwardRef as ReactComponent };